export default "__VITE_ASSET__NgII7Ics__"